/* src/app/forms/wizard-configuracao/data-transform/data-transform.component.scss */
.title-panel {
  width: 100%;
  font-size: large;
  font-weight: 500;
  margin-bottom: 6px;
}
.info {
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  padding: 15px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
  background-color: #FFFFE1;
  font-weight: 300;
  text-align: center;
}
.full-width {
  width: 100%;
}
.grid-input {
  height: 100%;
  width: 100%;
}
.more-options {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 90%;
  padding-right: 10px;
  padding-left: 10px;
}
.more-options-horizontal {
  display: flex;
  flex-direction: row;
  gap: 4px;
}
.more-options-offSet {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  border: solid 1px #ccc;
  border-radius: 4px;
  padding: 10px;
  font-weight: 500;
  gap: 10px;
}
.more-options-offSet-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}
.more-options-offset-double-column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 2;
}
.more-options-offset-column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
}
.main-ddt {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 10px;
}
/*# sourceMappingURL=data-transform.component.css.map */
